import { Drawer, DialogElement } from "//www.shoe-shine.at/cdn/shop/t/5/assets/theme.js?v=103011424272941110861740763208";

class QuizElement extends Drawer {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.show();
  }
}

class QuizModal extends HTMLElement {
  constructor() {
    super();
    this.step = 1;
    this.progressbar = this.closest("section").querySelector("progress-bar");
    console.log(this.progressbar);
    this.data = {};
    this.data2 = {};
    this.buttons = this.querySelectorAll("button");
    this.buttons.forEach((button) => {
      button.addEventListener("click", this.handleButtonClick.bind(this));
    });
    this.steps = this.querySelectorAll("[data-step]").length;
    this.createDots(this.steps);
    this.prevButtons = this.querySelectorAll("[data-prev]");
    if (this.prevButtons) {
      this.prevButtons.forEach((button) => {
        button.addEventListener("click", this.handlePrev.bind(this));
      });
    }
  }

  handleButtonClick(e) {
    this.step = parseInt(e.target.closest(".step").getAttribute("data-step"));
    this.data[this.step] = e.target
      .closest("button")
      .getAttribute("data-value");

const quizKey = e.target.closest("[data-quiz-value]")?.getAttribute("data-quiz-value");
const selectedText = e.target.closest("button")?.innerText.trim().toLowerCase();
if (quizKey && selectedText) {
  this.data2[quizKey] = selectedText;
}


    console.log(this.step, this.data, this.steps);

    if (e.target.closest("button")?.hasAttribute("data-shoetype")) {
      this.shoetype = e.target.closest("button")?.getAttribute("data-shoetype");
    }

    if (this.step === 1 && this.shoetype) {
      console.log("Setting Shoetype in Texts", this.shoetype);
      this.querySelectorAll(".prose").forEach((item) => {
        item.innerHTML = item.innerHTML.replaceAll(
          "[shoetype]",
          `${this.shoetype}e`
        );
      });
    }

    // Neu strukturierte Logik für alle Schuhtypen
    if (this.data[1] && !this.shoetypeProcessed) {
      const shoetype = this.shoetype;
      
      // Sneaker: 1, 2, 3, 3b
      if (shoetype === "Sneaker") {
        console.log("SNEAKER: Keeping steps 1, 2, 3, 3b");
        this.querySelectorAll("[data-step]").forEach((item) => {
          const step = item.getAttribute("data-step");
          if (step !== "1" && step !== "2" && step !== "3" && step !== "3b") {
            item.remove();
          }
        });
      }
      // Arbeitsschuh: 1, 2, 3, 3b
      else if (shoetype === "Arbeitsschuh") {
        console.log("ARBEITSSCHUH: Keeping steps 1, 2, 3, 3b");
        this.querySelectorAll("[data-step]").forEach((item) => {
          const step = item.getAttribute("data-step");
          if (step !== "1" && step !== "2" && step !== "3" && step !== "3b") {
            item.remove();
          }
        });
      }
      // Damenschuh: 1, 2, 3, 4, 5, 6, 7, 8
      else if (shoetype === "Damenschuh") {
        console.log("DAMENSCHUH: Keeping steps 1, 2, 3, 4, 5, 6, 7, 8");
        this.querySelectorAll("[data-step]").forEach((item) => {
          const step = item.getAttribute("data-step");
          if (step !== "1" && step !== "2" && step !== "3" && step !== "4" && step !== "5" && step !== "6" && step !== "7" && step !== "8") {
            item.remove();
          }
        });
      }
      // Halbschuh: 1, 2, 3, 4, 5, 6, 7, 8
      else if (shoetype === "Halbschuh") {
        console.log("HALBSCHUH: Keeping steps 1, 2, 3, 4, 5, 6, 7, 8");
        this.querySelectorAll("[data-step]").forEach((item) => {
          const step = item.getAttribute("data-step");
          if (step !== "1" && step !== "2" && step !== "3" && step !== "4" && step !== "5" && step !== "6" && step !== "7" && step !== "8") {
            item.remove();
          }
        });
      }
      // Winterstiefel: 1, 2, 3, 4, 7, 8 (KEIN Reißverschluss, KEIN Absatz)
      else if (shoetype === "Winterstiefel") {
        console.log("WINTERSTIEFEL: Keeping steps 1, 2, 3, 4, 7, 8 (no reißverschluss)");
        this.querySelectorAll("[data-step]").forEach((item) => {
          const step = item.getAttribute("data-step");
          if (step !== "1" && step !== "2" && step !== "3" && step !== "4" && step !== "7" && step !== "8") {
            item.remove();
          }
        });
      }
      // Sport-Laufschuh: 1, 2, 3, 4, 7, 8
      else if (shoetype === "Sport-Laufschuh") {
        console.log("SPORT-LAUFSCHUH: Keeping steps 1, 2, 3, 4, 7, 8");
        this.querySelectorAll("[data-step]").forEach((item) => {
          const step = item.getAttribute("data-step");
          if (step !== "1" && step !== "2" && step !== "3" && step !== "4" && step !== "7" && step !== "8") {
            item.remove();
          }
        });
      }

      // Reißverschluss für alle außer Winterstiefel entfernen
      if (shoetype !== "Winterstiefel") {
        this.querySelector("[data-zip]")?.remove();
      }

      // Schritt-Nummern neu zuordnen
      this.steps = this.querySelectorAll("[data-step]").length;
      this.createDots(this.steps);
      this.shoetypeProcessed = true;
      this.querySelectorAll("[data-step]").forEach((item, index) => {
        item.setAttribute("data-step", index + 1);
      });
    }

    if (this.step < this.steps) {
      this.setFrame(this.step);
    } else {
      this.evaluate();
      this.setFrame(this.steps);
    }
  }

  setFrame(frame) {
    this.currentFrame = frame;
    // if(this.shoetype == "Sneaker" || this.shoetype == "Arbeitsschuh"){
    //   frame = 0;
    // }
    this.style.setProperty("--scroll", `-${frame}00%`);
    this.progressbar.style.setProperty(
      "--progress",
      `${(100 / this.steps) * frame}%`
    );

    this.progressbar.querySelectorAll(".quiz-dot").forEach((item, index) => {
      if (index < this.currentFrame) {
        item.classList.add("done");
      }
    });
  }

  createDots(stepAmount) {
    this.progressbar.querySelectorAll(".quiz-dot").forEach((item) => {
      item.remove();
    });
    for (let i = 0; i < stepAmount; i++) {
      let dotElement = document.createElement("div");
      dotElement.style.setProperty("--left", `${(i / this.steps) * 100}%`);
      dotElement.classList.add("quiz-dot");
      this.progressbar.appendChild(dotElement);
    }
  }

  handlePrev(e) {
    this.setFrame(this.currentFrame - 1);
  }

  evaluate() {
    let data = this.data;
    let data2 = this.data2;

    localStorage.setItem("upsells", JSON.stringify(data));
    localStorage.setItem("upsells2", JSON.stringify(data2));

    window.location = `${data[1]}?eval=true`;
  }
}

window.customElements.define("quiz-element", QuizElement);

window.customElements.define("quiz-modal", QuizModal);

document.addEventListener("DOMContentLoaded", () => {
  function checkForElement(attempt = 0) {
    if (attempt >= 5) return;

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("eval") === "true") {
      const checkboxes = document.querySelectorAll(
        '.wcpa_form_outer input[type="checkbox"]'
      );

      if (!checkboxes.length) {
        return setTimeout(() => checkForElement(attempt + 1), 500);
      }

      const data2 = JSON.parse(localStorage.getItem("upsells2"));
      if (!data2) return;

      const hasSpitze = data2.spitzen === "ja";
      const hasFerse = data2.fersen === "ja";
      const hasSohleTauschen = data2.sohle_tauschen === "ja";
      const sohlenart = data2.sohlenart;
      const hasSneakerSohleTauschen = data2.sohle_tauschen_sneaker === "ja";

      // Spezialbehandlung: Nur wenn beide gewählt, dann Kombi aktivieren
      const activateCombined = hasSpitze && hasFerse;

      // Hauptmapping (ohne Spitzen & Fersen)
      const matchMap = {
        reinigungsart: ["intensivpflege"],
        schuhbänder: ["schuhbänder tauschen", "schnürsenkel tauschen"],
        absätze: ["absatz neu"],
        reißverschluss: ["reißverschluss tauschen"],
        spitzen: ["spitzen reparieren"],
        fersen: ["fersen reparieren"],
        sohle_tauschen: ["sohle tauschen", "gummisohle tauschen", "ledersohle tauschen"],
        sohlenart: ["gummisohle tauschen", "ledersohle tauschen"],
        sohle_tauschen_sneaker: ["sohle tauschen"]
      };

      const synonymOverrides = {
        "intensive pflege": "intensivpflege",
        "normale pflege": "normale pflege"
      };

      checkboxes.forEach((box) => {
        const boxValue = box.value.trim().toLowerCase();
        let shouldCheck = false;

        // ✅ Spezialfall: Kombi-Checkbox
        if (
          activateCombined &&
          boxValue.includes("spitzen") &&
          boxValue.includes("fersen")
        ) {
          shouldCheck = true;
        }

        // ✅ Einzel-Spitze oder -Ferse NUR wenn nicht beide
        if (!shouldCheck && !activateCombined) {
          if (hasSpitze && boxValue.includes("spitzen") && !boxValue.includes("fersen")) {
            shouldCheck = true;
          }
          if (hasFerse && boxValue.includes("fersen") && !boxValue.includes("spitzen")) {
            shouldCheck = true;
          }
        }

        // ✅ Sohlen-Spezialbehandlung (Halbschuhe)
        if (!shouldCheck && hasSohleTauschen && sohlenart) {
          if (sohlenart === "gummisohle" && boxValue.includes("gummisohle tauschen")) {
            shouldCheck = true;
          } else if (sohlenart === "ledersohle" && boxValue.includes("ledersohle tauschen")) {
            shouldCheck = true;
          }
        }

        // ✅ Sneaker/Arbeitsschuh Sohle-Spezialbehandlung
        if (!shouldCheck && hasSneakerSohleTauschen) {
          if (boxValue.includes("sohle tauschen") && !boxValue.includes("gummisohle") && !boxValue.includes("ledersohle")) {
            shouldCheck = true;
          }
        }

        // ✅ Standard-Fälle
        if (!shouldCheck) {
          for (const [quizKey, labels] of Object.entries(matchMap)) {
            if (quizKey === "spitzen" || quizKey === "fersen" || quizKey === "sohle_tauschen" || quizKey === "sohlenart" || quizKey === "sohle_tauschen_sneaker") continue; // schon behandelt

            let answer = (data2[quizKey] || "").trim().toLowerCase();
            if (quizKey === "reinigungsart") {
              answer = synonymOverrides[answer] || answer;
            }

            if (
              answer === "ja" &&
              labels.some((label) => boxValue.includes(label))
            ) {
              shouldCheck = true;
              break;
            }

            if (
              answer &&
              labels.some((label) => boxValue.includes(label) && answer.includes(label))
            ) {
              shouldCheck = true;
              break;
            }
          }
        }

        if (shouldCheck && !box.checked) {
          box.checked = true;
          box.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }
  }

  checkForElement();
});
